export default "__VITE_ASSET__rem$WWfX__"